// extracted by mini-css-extract-plugin
export default {"form":"A0Tru","info":"po2NY"};